import type { TaskType } from '@econtractor/types';
import { UserNameItem } from 'modules/user';
import TaskStatusBadge from '../shared/TaskStatusBadge';
import TaskTermInterval from '../shared/TaskTermInterval';
import TaskTypeChip from '../shared/TaskTypeChip';
import TaskRemindButton from '../shared/TaskRemindButton';

interface TaskTableRowProps {
    task: TaskType;
    onOpenTask?: (taskId: number) => void;
}

const TaskTableRow = ({ task, onOpenTask }: TaskTableRowProps) => (
    <tr
        className={[
            onOpenTask ? 'cursor-pointer' : undefined,
            Number(task.taskDeleted) ? 'task-row-deleted' : undefined,
        ]
            .filter(Boolean)
            .join(' ') || undefined}
        onClick={onOpenTask ? () => onOpenTask(task.ID) : undefined}
        onKeyDown={
            onOpenTask
                ? (e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          onOpenTask(task.ID);
                      }
                  }
                : undefined
        }
        role={onOpenTask ? 'button' : undefined}
        tabIndex={onOpenTask ? 0 : undefined}
    >
        <td className="task-col-name">
            <div className="task-name-type">
                <div className="task-name-title fw-medium text-truncate" title={task.taskName || undefined}>
                    {task.taskName || '—'}
                </div>
                <div className="task-name-type__chip mt-1">
                    <TaskTypeChip
                        name={task.taskTypeName}
                        icon={task.taskTypeIcon}
                        colors={task.taslTypeJson}
                        fontSize="0.7rem"
                    />
                </div>
            </div>
        </td>
        <td className="task-col-status">
            <TaskStatusBadge
                status={Number(task.taskStatus)}
                dateEnd={task.dateEnd}
                taskDeleted={task.taskDeleted}
            />
        </td>
        <td
            className="task-col-term"
            style={{
                whiteSpace: 'normal',
                overflow: 'visible',
                verticalAlign: 'top',
            }}
        >
            <TaskTermInterval
                taskId={task.ID}
                dateStart={task.dateStart}
                dateEnd={task.dateEnd}
                taskStatus={Number(task.taskStatus)}
                withTime={Boolean(task.withTime)}
            />
        </td>
        <td className="task-col-executor">
            {task.executorUser?.ID ? (
                <UserNameItem user={task.executorUser} />
            ) : (
                <span className="text-muted">—</span>
            )}
        </td>
        <td className="task-col-controller">
            {task.controllerUser?.ID ? (
                <UserNameItem user={task.controllerUser} />
            ) : (
                <span className="text-muted">—</span>
            )}
        </td>
        <td className="task-col-actions" onClick={(e) => e.stopPropagation()}>
            <TaskRemindButton task={task} variant="table" />
        </td>
    </tr>
);

export default TaskTableRow;
